import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=18417503&scoped=true&"
import script from "./NewPassword.vue?vue&type=script&lang=js&"
export * from "./NewPassword.vue?vue&type=script&lang=js&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewPassword.vue?vue&type=style&index=1&id=18417503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18417503",
  null
  
)

export default component.exports